import React from 'react';
import { Box, Typography } from '@material-ui/core';

interface Props {
  stepNumber: number;
  title: string;
  subTitle: string;
}

const Step: React.FunctionComponent<Props> = ({
  stepNumber,
  title,
  subTitle,
}) => {
  return (
    <Box style={{ maxWidth: '343px' }}>
      <Box display="flex" alignItems="flex-end" mb={1}>
        <Typography>step</Typography>
        <Box mr={1} />
        <Box mb={-0.5}>
          <Typography color="primary" variant="h4" component="p">
            {stepNumber}
          </Typography>
        </Box>
      </Box>
      <Typography style={{ maxWidth: '300px' }} variant="h6" component="h4">
        {title}
      </Typography>
      <Box mt={1} />
      <Typography>{subTitle}</Typography>
    </Box>
  );
};

export default Step;
